import { errProcess } from './err-features/err-process';
export const processFault = (options) => [errProcess(options)];
